import AccountProvider from "components/common/Context/AccountContext"
import { allChangeRequestStates } from "constants/Constants"
import { getCrDetails } from "extensions/usoc/api/service"
import { useContext, useMemo } from "react"
import { useSelector } from "react-redux"
import useSWR from "swr"
import { getDateParams, splitDateRange } from "utils/date"
import { isAnyAPIFailed } from "utils/nodata"
import { batchAPICalls, retryFailedRequests } from "utils/retryFailedRequests"

import useExtension from "./useExtension"
import useUserAuth from "./useUserAuth"

// async function fetchCrDetails(auth, extension, projectId, params) {
//   const host = extension?.config?.env?.clientApiGateway?.URL
//   const results = []
//   for (const param of params) {
//     const result = await retryFailedRequests({ auth, host }, projectId, param, getCrDetails)
//     results.push(result);

//   }
//   return results
// }

export default function ({
  dateRangeFilter,
  condition = true,
  stateFilter = allChangeRequestStates
}) {
  const auth = useUserAuth()
  const extension = useExtension()

  const projectID = useSelector((state) => {
    return state.settings.currentProject
  })

  const { selectedAccounts: accounts } = useContext(AccountProvider)

  const selectedAccounts = useMemo(() => {
    const accountIds = []
    // const accountNames = []
    accounts.forEach((account) => {
      if (account.account_number === "EMPTY") accountIds.push("")
      // else if (account.account_number.search(gcpAccountIdRegex) >= 0)
      //   accountNames.push(account.account_number)
      else accountIds.push(account.account_number)
    })
    return { accountIds }
  }, [accounts])

  const dateRangeFilters = useMemo(() => {
    return Array.isArray(dateRangeFilter) ? dateRangeFilter : [dateRangeFilter]
  }, [dateRangeFilter])

  const dateRangeSegmentsArray = useMemo(() => {
    return dateRangeFilters.map((dateRangeFilter) =>
      splitDateRange(dateRangeFilter)
    )
  }, [dateRangeFilters])

  const changeRequestParams = useMemo(() => {
    return dateRangeSegmentsArray
      .map((dateRangeSegments) =>
        dateRangeSegments.map(
          (dateRangeSegment) =>
            `state=${stateFilter || allChangeRequestStates}&${getDateParams(
              dateRangeSegment
            )}`
        )
      )
      .flat()
  }, [dateRangeSegmentsArray, stateFilter])

  const { data: changeRequestResponses } = useSWR(
    () =>
      projectID && condition
        ? changeRequestParams.map(
          (param) =>
            `/projects/${projectID}/get_change_request_details?${param}`
        )
        : null,
    () => batchAPICalls(auth, extension, projectID, changeRequestParams, getCrDetails),
    { suspense: true }
  )

  const accountFilteredChangeRequestDetails = useMemo(() => {
    let i = 0
    return dateRangeSegmentsArray.map((dateRangeSegments) => {
      const slicedChangeRequestDetails =
        changeRequestResponses?.slice(i, i + dateRangeSegments.length) || []
      i += dateRangeSegments.length
      return {
        data: slicedChangeRequestDetails
          ?.map((eachResponse) =>
            Array.isArray(eachResponse.data)
              ? eachResponse.data.filter(
                (eachData) =>
                  selectedAccounts.accountIds.includes(eachData.account_id)
                // ||
                // selectedAccounts.accountNames.includes(
                //   eachData.cloud_service_account
                // )
              )
              : []
          )
          .flat(),
        error: isAnyAPIFailed(slicedChangeRequestDetails)
      }
    })
  }, [
    changeRequestResponses,
    dateRangeSegmentsArray,
    selectedAccounts.accountIds
  ])

  return Array.isArray(dateRangeFilter)
    ? accountFilteredChangeRequestDetails
    : accountFilteredChangeRequestDetails[0]
}
